import React, { useState } from "react";
import { useLanguage } from "../../Translations/LenguageContext";
import NewNetworkModal from "./NewNetorkModal";
import CanvasAnimation from "../../Components/CanvasItems";

const EmptyNetworkModal = ({ fetchRecords, title, subtitle, item }) => {
    const { t } = useLanguage()
    const [openModal, setOpenModal] = useState(false)

    const OpenSelectedModal = () => {
        setOpenModal(true)
    }


    return (
        <div className="empty_cont fade-in">
            <div className="icon_cont">
                <p className="icon_cont_title">{title}</p>
                <p className="icon_cont_subtitle">{subtitle}</p>

                {item != "" && (
                    <div className="canvas_anim_empty_cont">
                        <CanvasAnimation type={item} />
                    </div>
                )}
            </div>
            <div className="btn_cont">
                <button className="connect_email_btn" onClick={OpenSelectedModal}><i className="fa-solid fa-plus"></i> {t.create}</button>
            </div>
            <NewNetworkModal
                show={openModal}
                handleClose={() => setOpenModal(false)}
                fetchRecords={fetchRecords}
            />
        </div>
    )
}

export default EmptyNetworkModal